import { createAction, props } from '@ngrx/store';
import { Store } from '../../types/stores/store';

export const getStores = createAction('[Stores] Get stores');
export const getStoresCompleted = createAction('[Stores] Get stores loaded', props<{ stores: Store[] }>());
